import axios from 'axios'
import { useFormikContext } from 'formik'
import { useEffect } from 'react'

export const AddNewUser = (setFieldValue, values) => {

  let participants = values.participants;
      participants.push({ id:values.participants[values.participants.length-1].id + 1, firstName: '', lastName: '', email: '', phone: '', })
      setFieldValue(participants);
}
export const getPatricipantIndex = (id, values) => {

  const participants = values.participants
  let userIndex = false;

  participants.forEach((user, index) => {
    if (user.id == id) {
      userIndex = index;
    }
  })
  return userIndex

}

export async function sendOrderToServer(values) {
  let finalValues = values

  if (values.orderByOrganization === false) {
    if (finalValues.nip) {
      finalValues.nip = ''
    }
  }
  if (values.differentBillingData === false) {
    if (finalValues.fv_nip) {
      finalValues.fv_nip = ''
    }
  }
  if (values.orderPerson === 0) {
    values.orderPerson = ''
  }



  return new Promise((resolve, reject) => {
        axios.post(data.rest.endpoint, finalValues).then((res) => {
            resolve(res);
        }).catch((err) => {
            reject(err);
        })
    })
}

export function getTerminParams(allTermins, termin){
  let terminID = termin;
  let terminParams = null;

  allTermins.forEach((term)=>{
    if(term.id == termin){
      terminParams = term;
    }
  })
  return terminParams;
}
export const getFieldErrorNames = (formikErrors) => {
  const transformObjectToDotNotation = (obj, prefix = '', result = []) => {
    Object.keys(obj).forEach((key) => {
      const value = obj[key]
      if (!value) return

      const nextKey = prefix ? `${prefix}.${key}` : key
      if (typeof value === 'object') {
        transformObjectToDotNotation(value, nextKey, result)
      } else {
        result.push(nextKey)
      }
    })

    return result
  }

  return transformObjectToDotNotation(formikErrors)
}

export const scrollToErrorField = () => {
  let errorFields = document.querySelectorAll( '.fieldCol .field-error' );
  let errorField = errorFields[0];
  let firstInput = document.querySelectorAll( '.fieldCol .form-control' )[0];

  if ( errorFields.length === 0 ) {

    // If user clicked "go to payment" button without clicking anywhere on the form, errorFields returns empty array. We scroll to first input in that case.
    if ( firstInput.value === '' ) {
      errorField = firstInput;
    } else {
      return;
    }

  }

  setTimeout(() => {
    errorField.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }, 100); // It doesn't work in Chrome without setTimeout
}

export function  isSingleCharacterString (string){
  return /^(.)\1+$/.test(string)
}